import {
  ALLOWED_AVATAR_MIME_TYPES,
  AVATAR_ERROR_TYPE,
  MAX_AVATAR_FILE_SIZE_BYTE,
  MIN_AVATAR_RESOLUTION,
} from 'src/components/common/DoctorAvatarEditor/constants'

/**
 * Читает файл как data URL для отправки на process-avatar.
 */
export function readFileAsDataUrl(file: File) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      resolve(String(reader.result || ''))
    }
    reader.onerror = () => {
      reject(new Error('file read error'))
    }
    reader.readAsDataURL(file)
  })
}

function getImageSize(dataUrl: string) {
  return new Promise<{ width: number, height: number }>((resolve, reject) => {
    const image = new Image()

    image.onload = () => {
      resolve({
        width: image.width,
        height: image.height,
      })
    }
    image.onerror = () => {
      reject(new Error('image load error'))
    }
    image.src = dataUrl
  })
}

/**
 * Код ошибки файла до загрузки, либо пустая строка если файл подходит.
 */
export function getAvatarFileErrorType(file: File) {
  const isAllowedMime = ALLOWED_AVATAR_MIME_TYPES.some(type => type === file.type)

  if (!isAllowedMime) {
    return AVATAR_ERROR_TYPE.unsupportedFormat
  }

  if (file.size > MAX_AVATAR_FILE_SIZE_BYTE) {
    return AVATAR_ERROR_TYPE.tooBigWeight
  }

  return ''
}

/**
 * Код ошибки по разрешению картинки, либо пустая строка.
 */
export async function getAvatarImageErrorType(dataUrl: string) {
  const { width, height } = await getImageSize(dataUrl)
  const isLargeEnough = width >= MIN_AVATAR_RESOLUTION && height >= MIN_AVATAR_RESOLUTION

  return isLargeEnough ? '' : AVATAR_ERROR_TYPE.smallSize
}
